import { useState, useEffect } from "react";
import CandidateGeneralView from "./CandidateGeneralView";
import CandidateGeneralEdit from "./CandidateGeneralEdit";
import {disbaleCandidateLogin, enableCandidateLogin} from "@/api/candidates.jsx";

export default function CandidateGeneral({ data }) {
    const [isEditing, setIsEditing] = useState(false);
    const [candidateData, setCandidateData] = useState(null);

    useEffect(() => {
        if (data) {
            console.log('general',data)
            setCandidateData(data);
        }
    }, [data]);

    const handleSave = (updatedData) => {
        setCandidateData(updatedData);
        setIsEditing(false);
    };

    const handleToggleLogin = async ()=>{
        const ftn = candidateData.loginEnabled ? disbaleCandidateLogin : enableCandidateLogin
        const oo = candidateData.loginEnabled ? 'disable' : 'enable'

        const data = await ftn(candidateData.slugId)

        if(data){
            setCandidateData(data)
        }
    }

    if (!candidateData) {
        return <p>Loading candidate information...</p>;
    }

    return isEditing ? (
        <CandidateGeneralEdit data={candidateData} onSave={handleSave} onCancel={() => setIsEditing(false)} />
    ) : (
        <CandidateGeneralView data={candidateData} onToggleLogin={handleToggleLogin} onEdit={() => setIsEditing(true)} />
    );
}
